// extracted by mini-css-extract-plugin
module.exports = {"discussion":"disqus-comments-module--discussion--2pPI5"};